<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-header font-weight-B fs-1r">Add Vehicle</div>
        <div class="card-body">
          <div class="row justify-content-center">
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="">Vehicle Type : </label>
              <input
                type="text"
                class="form-control"
                placeholder="Vehicle type"
                [(ngModel)]="vehicleType"
              />
            </div>
            <div class="col-md-3">
              <label for="">Capacity : </label>
              <input
                type="number"
                [(ngModel)]="capacity"
                class="form-control"
                placeholder="Capacity"
                min="0"
              />
            </div>

            <div class="col-md-2"></div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="">Rating (Out of 5) : </label>
              <input
                type="number"
                [(ngModel)]="rating"
                class="form-control"
                placeholder="rating"
                max="5"
                min="1"
              />
            </div>
            <div class="col-md-3">
              <label for="">Vehicle Size (Length) : </label>
              <input
                type="text"
                [(ngModel)]="vehicleDimentions_L"
                class="form-control"
                placeholder="Length (ex-1ft)"
              />
            </div>

            <div class="col-md-2"></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for=""> Vehicle Size (Breadth) : </label>
              <input
                type="text"
                [(ngModel)]="vehicleDimentions_B"
                class="form-control"
                placeholder="breadth (ex-1ft)"
              />
            </div>
            <div class="col-md-3">
              <label for=""> Vehicle Size (Height) : </label>
              <input
                type="text"
                [(ngModel)]="vehicleDimentions_H"
                class="form-control"
                placeholder="Height (ex-1ft)"
              />
            </div>
            <div class="col-md-2"></div>
          </div>

          <div class="row justify-content-center">
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="">Original Price(/KM): </label>
              <input
                type="text"
                [(ngModel)]="originalPrice"
                class="form-control"
                placeholder="Original price"
              />
            </div>
            <div class="col-md-3">
              <label for="">Discount Price(/KM): </label>
              <input
                type="text"
                [(ngModel)]="discountPrice"
                class="form-control"
                placeholder="Discount price "
              />
            </div>
            <div class="col-md-2"></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="">Terms & Conditions : </label>
              <input
                type="text"
                [(ngModel)]="termsAndConditions"
                class="form-control"
                placeholder="Terms & Conditions"
              />
            </div>
            <div class="col-md-3">
              <label for="">Vehicle Image : </label>
              <div>
                <input
                  type="file"
                  (change)="getVehicleImage($event, 'VEHICLE_IMAGE')"
                  placeholder="Vehicle Image"
                />
                <div *ngIf="isValidImage == true" class="text-danger">
                  Please Select image file
                </div>
                <div *ngIf="isImageUploaded == true" class="text-success">
                  Image Uploaded Successfully
                </div>
              </div>
            </div>
            <div class="col-md-2"></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for=""> Current Active Status : </label> <br />
              <label class="switch">
                <input
                  type="checkbox"
                  (ngModelChange)="currentActiveStatus($event)"
                  [(ngModel)]="activeStatus"
                />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="col-md-3">
              <label for="">Labour Available : </label> <br />
              <label class="switch">
                <input
                  type="checkbox"
                  (ngModelChange)="labourAvail($event)"
                  [(ngModel)]="labourAvailable"
                />
                <span class="slider round"></span>
              </label>
            </div>

            <div class="col-md-2"></div>
          </div>

          <!-- Select Range and set Prices -->
          <div class="row" *ngIf="allRanges.length">
            <!-- Range Selection Dropdown -->
            <div class="col-md-2"></div>
            <div class="col-md-3">
              <label for="rangeSelect">Select Range (KM):</label>
              <select
                id="rangeSelect"
                [(ngModel)]="selectedRange"
                name="rangeSelect"
                class="form-control"
                (change)="onRangeChange()"
              >
                <option value="">Select Range</option>
                <option *ngFor="let range of allRanges" [ngValue]="range">
                  {{ range.min }} - {{ range.max }} KM
                </option>
              </select>
            </div>

            <!-- Price Input -->
            <div class="col-md-2">
              <label for="price">Price:</label>
              <input
                type="number"
                min="0"
                id="price"
                [(ngModel)]="priceInput"
                name="price"
                class="form-control"
                placeholder="Enter price"
                required
              />
            </div>

            <!-- Discounted Price Input -->
            <div class="col-md-2">
              <label for="discountedPrice">Discount Price:</label>
              <input
                type="number"
                min="0"
                id="discountedPrice"
                [(ngModel)]="discountedPriceInput"
                name="discountedPrice"
                class="form-control"
                placeholder="Enter discounted price"
                required
              />
            </div>

            <!-- Add Vehicle Price Button -->
            <div class="col-md-2 d-flex align-items-end">
              <button (click)="addVehiclePrice()" class="btn btn-primary">
                Add
              </button>
            </div>
          </div>

          <!-- Display Message below the inputs -->
          <div class="text-center m-0 p-0">
            <p
              *ngIf="message"
              [ngClass]="
                messageType === 'error' ? 'text-danger' : 'text-success'
              "
            >
              {{ message }}
            </p>
          </div>

          <!-- Table displaying vehicle prices -->
          <div class="row justify-content-center" *ngIf="vehiclePrice.length">
            <div class="col-md-8">
              <h3 class="mt-4">Vehicle Prices:</h3>
              <table class="table table-bordered table-striped table-hover">
                <thead>
                  <tr>
                    <th>Range (KM)</th>
                    <th>Price (per KM)</th>
                    <th>Discounted Price (per KM)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let vp of vehiclePrice">
                    <td>{{ vp.min }} - {{ vp.max }}</td>
                    <td>{{ vp.price }}</td>
                    <td>{{ vp.discountedPrice }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="row mt-3 mb-3 text-center">
            <div class="col-md-12">
              <button
                (click)="checkAllRangesUpdated()"
                [disabled]="
                  capacity == '' ||
                  originalPrice == '' ||
                  vehicleDimentions_L == '' ||
                  vehicleDimentions_B == '' ||
                  vehicleDimentions_B == '' ||
                  discountPrice == '' ||
                  vehicleType == '' ||
                  isValidImage == true ||
                  termsAndConditions == '' ||
                  imageUrl == ''
                "
                class="btn btn-primary btn-lg btn-block"
              >
                Add Vehicle
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
